<ion-chip
  id="getm-tag"
  mode="ios"
  [color]="color"
  [ngClass]="classResult + ' ' + 'getm-tag-' + fill"
>
  <ng-container *ngIf="icon">
    <ion-icon [name]="icon"></ion-icon>
  </ng-container>

  <ng-container *ngIf="label">
    <ion-label>{{ label }}</ion-label>
  </ng-container>
</ion-chip>
